// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Wait on God alone in stillness, O my soul;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for in him is my hope.<br> </p> </div></div>";
// Exports
module.exports = code;